<template>
  <v-app>
    <header
      v-show="!loading"
      v-if="$router.currentRoute.name == 'Home'"
      class="site-header"
      data-top="background: rgba(255,255,255,0); box-shadow: 0px 0px 20px 6px rgba(0, 0, 0, 0);"
      data-top-bottom="background: rgba(255,255,255,1); box-shadow: 0px 0px 20px 6px rgba(0, 0, 0, 0.2);"
    >
      <nav id="primary-navigation" class="site-navigation">
        <div class="container">
          <div class="navbar-header page-scroll">
            <button
              type="button"
              class="navbar-toggle collapsed"
              aria-expanded="false"
            >
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>

            <a href="#search" class="site-logo">
              <img
                src="./assets/logo.png"
                alt="logo"
                style="max-height: 32px"
              />
            </a>
          </div>
          <div class="main-menu">
            <ul class="nav navbar-nav navbar-right">
              <li class="page-scroll"><a href="#search">Pesquisa</a></li>
              <li class="page-scroll"><a href="#indicators">Indicadores</a></li>
              <li class="page-scroll">
                <a href="#publications">Publicações</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    <v-main>
      <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
      <router-view v-else />
    </v-main>
  </v-app>
</template>

<script>
import http from "@/http";
export default {
  name: "app",
  created() {
    http.get("/schools").then((r) => {
      this.$store.state.schools = r.data;
      this.loading = false;
    });
  },
  data() {
    return {
      loading: true,
    };
  },
};
</script>